/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<
  defs.tms.IPage<defs.tms.CustomsDeclarationMasterResponseDto>
>;
export function request(
  params: API.tms.customsDeclarationMaster.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsDeclarationMaster/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
